<template>
	<Dialog
		:dialog-visible="modelValue"
		title="Update Available"
		message="A new version of LiveSwitch is ready. Refresh now to get the latest updates."
		agree-text="Refresh Now"
		cancel-text="Remind Me Later"
		@agree="onRefresh"
		@cancel="onSnooze" />
</template>

<script setup lang="ts">
	import { watch } from "vue";
	import Dialog from "@/components/Dialog.vue";
	import { snooze, SNOOZE_MS, formatSnoozeDuration } from "@/composables/useVersionCheck";

	const modelValue = defineModel<boolean>({ required: true });

	watch(modelValue, (visible) => {
		if (visible) {
			console.info("[version-check] Update dialog shown");
		}
	});

	function onRefresh(): void {
		window.location.reload();
	}

	function onSnooze(): void {
		console.info(`[version-check] User snoozed update for ${formatSnoozeDuration(SNOOZE_MS)}`);
		snooze(SNOOZE_MS);
	}
</script>
